const dashboard = {
    title: 'Dashboard',
    subtitle: 'Überwachen Sie Ihre API-Produkte und Automatisierungsleistung',
    
    // Metrics
    totalRevenue: 'Gesamtumsatz',
    totalOperations: 'Gesamt-Operations',
    activeCustomers: 'Aktive Kunden',
    apiProducts: 'API-Produkte',
    fromLastMonth: 'vom letzten Monat',
    subscribed: '{{count}} Abonniert',
    credits: '{{count}} Credits',
    
    // Charts
    revenueTrend: 'Umsatztrend',
    revenueTrendDescription: 'Täglicher Umsatz der letzten 6 Wochen',
    operationsTrend: 'Operations-Trend',
    operationsTrendDescription: 'API-Aufrufe und Automation Runs im Zeitverlauf',
    totalCalls: 'Gesamtaufrufe',
    
    // Sections
    quickActions: 'Schnellaktionen',
    quickActionsDescription: 'Häufige Aufgaben und Arbeitsabläufe',
    topConsumers: 'Top-Nutzer',
    topConsumersDescription: 'Ihre Kunden mit der höchsten Nutzung diesen Monat',
    statusAlerts: 'Status & Warnungen',
    statusAlertsDescription: 'Systemzustand und wichtige Benachrichtigungen',
    
    // Quick Actions
    createApiProduct: 'API-Produkt erstellen',
    inviteCustomer: 'Kunden einladen',
    updateDocumentation: 'Dokumentation aktualisieren',
    configureStripe: 'Stripe konfigurieren',
    manageProducts: 'Produkte verwalten',
    
    // Status
    allSystemsOperational: 'Alle Systeme betriebsbereit',
    apiGatewayNormal: 'API-Gateway reagiert normal',
    highUsageWarning: 'Hohe Nutzung bei {{product}}',
    considerScaling: 'Skalierung oder Rate Limiting erwägen',
    viewProduct: 'Produkt anzeigen',
    
    // Additional translations
    healthy: '{{count}} healthy',
    warnings: '{{count}} Warnungen',
    details: 'Details',
    dailyRevenue: 'Täglicher Umsatz der letzten 6 Wochen',
    apiCallsAndAutomation: 'API-Aufrufe und Automation Runs im Zeitverlauf',
    commonTasks: 'Häufige Aufgaben und Arbeitsabläufe',
    viewAll: 'Alle anzeigen',
    highestUsageCustomers: 'Ihre Kunden mit der höchsten Nutzung diesen Monat',
    operations: 'Operations',
    systemHealth: 'Systemzustand und wichtige Benachrichtigungen',
    highUsageWeatherApi: 'Hohe Nutzung bei Wetter-API',
    operationsBreakdown: {
      api: '{{percent}} % API',
      automation: '{{percent}} % Automatisierung',
    },
  } as const;

export default dashboard;
